module.exports = __webpack_public_path__ + "static/media/uptake.145c39b8.png";